import type { ApiResponse } from '@/types';

function getApiBaseUrl(): string {
  const envUrl = import.meta.env.VITE_API_URL;
  if (!envUrl) return '/api';
  if (envUrl.endsWith('/api')) return envUrl;
  return envUrl.replace(/\/$/, '') + '/api';
}

const API_BASE_URL = getApiBaseUrl();

async function request<T>(endpoint: string, options: RequestInit = {}): Promise<T> {
  const token = localStorage.getItem('auth_token');
  
  const headers: HeadersInit = {
    'Content-Type': 'application/json',
    ...options.headers,
  };
  
  if (token) {
    (headers as Record<string, string>)['Authorization'] = `Bearer ${token}`;
  }
  
  const response = await fetch(`${API_BASE_URL}${endpoint}`, { ...options, headers });
  const data: ApiResponse<T> = await response.json();
  
  if (!response.ok || !data.success) {
    throw new Error(data.error || 'Unknown error');
  }
  
  return data.data as T;
}

// ============================================
// API CALLS
// ============================================

export interface NotificationSettings {
  notificationsEnabled: boolean;
}

export async function getNotificationSettings(): Promise<NotificationSettings> {
  return request('/notifications/settings');
}

export async function updateNotificationSettings(enabled: boolean): Promise<NotificationSettings> {
  return request('/notifications/settings', {
    method: 'POST',
    body: JSON.stringify({ enabled }),
  });
}

export async function sendTestNotification(): Promise<{ sent: boolean }> {
  return request('/notifications/test', {
    method: 'POST',
  });
}
